import React from "react";

const AllAgent = () => {
  return (
    <section className="section-agents section-t8 mt-3">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="title-wrap d-flex justify-content-between">
              <div className="title-box">
                <h2 className="title-a">Agents</h2>
              </div>
              <div className="title-link">
                <a to="/all">102 Agents</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AllAgent;
